import { Module } from 'vuex'
import _ from 'lodash'

export const session: Module<any, any> = {
  namespaced: true,
  state: {
    scrollPosition: 0
  },
  getters: {
    getPosition(state): number {
      return state.scrollPosition ?? 0
    }
  },
  mutations: {
    scrollTo(state, payload) {
      state.scrollPosition = payload
    }
  },
  actions: {
    scrollTo: async (context, payload) => {
      if (_.isNumber(payload)) {
        window.scrollTo(0, payload)
      } else {
        const el = document.getElementById(payload)
        if (el) {
          el.classList.add('scroll-element')
          setTimeout(() => {
            el.classList.remove('scroll-element')
          }, 1000)
          const y = el.getBoundingClientRect().top + window.scrollY - 300
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      }
    }
  }
}
